import _ from 'lodash';
import Vue from 'vue';
import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const defaultMinistry = {
  social: {},
  _embedded: {
    header_image: {},
    main_gallery: [],
    profile_image: {},
    roles: [],
    service_gallery: [],
    services: [],
  },
};

export default {
  actions: {
    async [actions.DO_DELETE_MINISTRY]({ commit }, payload) {
      const { id, ignore } = payload;
      const params = Object.assign(payload);
      delete params.id;
      delete params.ignore;
      const { data } = await HTTP.delete(`/ministries/${id}`, params);
      if (!ignore) commit(mutations.SET_MINISTRY, data.data.ministries[0]);
      return data;
    },
    async [actions.DO_GET_MINISTRY]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign(payload);
      delete params.id;
      const { data } = await HTTP.get(`/ministries/${id}`, { params });
      commit(mutations.SET_MINISTRY, data.data.ministries[0]);
      return data;
    },
    async [actions.DO_GET_MINISTRIES]({ commit }, params) {
      const { data } = await HTTP.get('/ministries', { params });
      commit(mutations.SET_MINISTRIES, data.data.ministries);
      return data;
    },
    async [actions.DO_CREATE_MINISTRY]({ commit }, params) {
      const { data } = await HTTP.post('/ministries', params);
      commit(mutations.SET_MINISTRY, data.data.ministries[0]);
      return data;
    },
    async [actions.DO_UPDATE_MINISTRY]({ commit }, params) {
      const { data } = await HTTP.patch(`/ministries/${params.id}`, params);
      commit(mutations.SET_MINISTRY, data.data.ministries[0]);
      return data;
    },
    async [actions.DO_DELETE_MINISTRY]({ commit }, params) {
      const { data } = await HTTP.delete(`/ministries/${params.id}`, params);
      return data;
    },
  },
  getters: {
    [getters.GET_MINISTRY]: state => state.ministry,
    [getters.GET_MINISTRY_FILTERS]: state => state.filters,
    [getters.GET_MINISTRY_MODE]: state => state.mode,
    [getters.GET_MINISTRY_REFRESH]: state => state.refresh,
    [getters.GET_MINISTRIES]: state => state.ministries,
  },
  mutations: {
    [mutations.ADD_TO_GALLERY_FOR_MINISTRY](state, payload) {
      state.ministry._embedded[payload.key].push(payload.val);
    },
    [mutations.ADD_ROLE_FOR_MINISTRY](state, role) {
      state.ministry._embedded.roles.push(role);
    },
    [mutations.ADD_SERVICE_FOR_MINISTRY](state, service) {
      state.ministry._embedded.services.push(service);
    },
    [mutations.INSERT_MINISTRY](state, payload) {
      const index = _.findIndex(state.ministries, { id: payload.val.id });
      if (index >= 0) {
        state.ministries.splice(index, 1);
      }
      state.ministries.splice(payload.index, 0, payload.val);
    },
    [mutations.INSERT_ROLE_FOR_MINISTRY](state, payload) {
      state.ministry._embedded.roles.splice(payload.index, 0, payload.val);
    },
    [mutations.REMOVE_FROM_GALLERY_FOR_MINISTRY](state, payload) {
      state.ministry._embedded[payload.key].splice(payload.index, 1);
    },
    [mutations.REMOVE_SERVICE_FOR_MINISTRY](state, service) {
      const index = _.findIndex(state.ministry._embedded.services, { id: service.id });
      state.ministry._embedded.services.splice(index, 1);
    },
    [mutations.REMOVE_ROLE_FOR_MINISTRY](state, payload) {
      state.ministry._embedded.roles.splice(payload.index, 1);
    },
    [mutations.SET_FIELD_FOR_ROLE_FOR_MINISTRY](state, field) {
      const { index } = field;
      const role = state.ministry._embedded.roles[index];
      Vue.set(role, field.key, field.val);
    },
    [mutations.SET_FIELD_FOR_SERVICE_FOR_MINISTRY](state, field) {
      const index = _.findIndex(state.ministry._embedded.services, { id: field.id });
      const service = state.ministry._embedded.services[index];
      Vue.set(service, field.key, field.val);
    },
    [mutations.SET_MINISTRY](state, ministry) {
      state.ministry = ministry;
    },
    [mutations.SET_MINISTRY_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.ministry;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_MINISTRY_FILTER_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.filters;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_MINISTRY_MODE](state, mode) {
      state.mode = mode;
    },
    [mutations.SET_MINISTRY_REFRESH](state, refresh) {
      state.refresh = refresh;
    },
    [mutations.SET_MINISTRIES](state, ministries) {
      state.ministries = ministries;
    },
    [mutations.SORT_GALLERY_FOR_MINISTRY](state, payload) {
      const gallery = state.ministry._embedded[`${payload.key}_gallery`];
      const element = gallery[payload.from];
      gallery.splice(payload.from, 1);
      gallery.splice(payload.to, 0, element);
    },
    [mutations.UNSET_MINISTRY](state) {
      state.ministry = _.cloneDeep(defaultMinistry);
    },
  },
  state: {
    ministry: _.cloneDeep(defaultMinistry),
    ministries: [],
    mode: 'ministries',
    filters: {
      approved: 'all',
      query: null,
    },
    refresh: false,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ministry.js